import React from 'react';
import { Route, Switch } from 'react-router-dom';
import "../utils/logging"; // custom logging

import '../css/App.css';
import Home from './pages/Home';
import Login from './pages/Login';
import Token from './pages/Token';
function App() {
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/",
    component: Home
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/t",
    component: Token
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/login",
    component: Login
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/home",
    component: Home
  }), /*#__PURE__*/React.createElement(Route, {
    component: Home
  }));
}
export default App;